import React, { Component } from 'react';
import _ from 'lodash';

const REQUEST_URL = '/system/inquiries/confirm_ajax'
const gtag = window.gtag;

class Confirm extends Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false
    };
  }
  componentDidMount() {
    //this.fetchData()
  }

  sendMail(){
    var that = this;

    this.setState({
      loading: true
    })

    $.ajax({
      url: REQUEST_URL,
      type: "POST",
      dataType: 'json',
      data: that.props.fieldValues,
      success: function (res) {

        try {
          gtag('event', 'contact', {
            'event_category': 'mail'
          });
        } catch( e ) {
          $.post( "/system/loggers/", { message: e.message, useragent: '' } );
        }
        that.props.nextStep();
        //if(res.status === 'OK'){
        //  return;
        //}
        //alert('送信に失敗しました。入力をやりなおしてください。');
      },
      error: function () {
        alert('送信に失敗しました。入力をやりなおしてください。');
        that.setState({
          loading: false
        })
      }
    })

  }

  render() {
    var that = this;
    let index = _.findIndex(that.props.shopMaster, function(v) { return Number(v.value) === Number(that.props.fieldValues.shop); });
    let shop_text = '';
    if(index !== -1){
      shop_text = that.props.shopMaster[index].text;
    }

    return (
      <div className="confirm_page">
        <h2 className="contact">以下の内容でよろしいですか？</h2>
        <h4>ご連絡先/お問合せ内容</h4>
        <table className="form-confirm">
          <tbody>
            <tr>
              <th>お名前</th>
              <td>{this.props.fieldValues.name}</td>
            </tr>
            <tr>
              <th>E-mail</th>
              <td>{this.props.fieldValues.email}</td>
            </tr>
            <tr>
              <th>件名</th>
              <td>{this.props.fieldValues.subject}</td>
            </tr>
            <tr>
              <th>お問合せ店名</th>
              <td><span>{shop_text}</span></td>
            </tr>
            <tr>
              <th>お問合せ内容</th>
              <td>
              {this.props.fieldValues.inquiry_txt.split('\n').map((item, key) => {
                return <span key={key}>{item}<br/></span>
              })}
              </td>
            </tr>
          </tbody>
        </table>
        <h4>お読みください</h4>
        <p>
          <span>お客様よりいただいた情報は、弊社</span>
          <a target="_blank" href="../privacy/index.html">「個人情報の取り扱いについて」</a>
          <span>に基づいて取り扱ってまいります。</span>
          <br />
        </p>
        <div className="row">
          <div className="btn_box">
            <div className="display-none">
              <span className="button loading-bt">
                <img src="/img/loading.gif" alt='Loading'/>
                <span>  Loading...</span>
              </span>
            </div>
            <div className={!this.state.loading  ? 'display-none' : ''}>
              <span className="button loading-bt">
                <img src={ '/img/loading.gif' } alt="loading" />
                <span>  Loading...</span>
              </span>
            </div>
            <div className={this.state.loading  ? 'display-none' : ''}>
              <a role="button" className="button" onClick={ this.props.prevStep }>&lt;&lt; 戻る</a>
              <span>&nbsp;&nbsp;&nbsp;</span>
              <a role="button" className="button" onClick={ this.sendMail.bind(this) }>送 信</a>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default Confirm;



// WEBPACK FOOTER //
// ./src/contact/Confirm.js